import { store } from '../../store/store';
import { getFormApplianceName } from './getFormApplianceName';

/**
 * @description formApplianceName is a selector function that retrieves the appliance name from the store's state.
 * It uses the getFormApplianceName utility function to extract the appliance name from the current state of the store.
 * If there is an error during this process, it catches the error, logs it to the console, and returns undefined.
 * @returns {Selection<string | undefined>} The appliance name from the store, or undefined if there was an error
 */
// export const formApplianceName = store
//   ? store.getSnapshot() .select((state) => getFormApplianceName(state))
//   : { get: () => undefined };
export const formApplianceName = {
  get: () => {
    const storeInstance = store.getSnapshot();
    return getFormApplianceName(storeInstance.context);
  },
};
